/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * PIXTAカテゴリ
 * @export
 * @interface PixtaCategory
 */
export interface PixtaCategory {
    /**
     * カテゴリID
     * @type {number}
     * @memberof PixtaCategory
     */
    id: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof PixtaCategory
     */
    name: string;
}

export function PixtaCategoryFromJSON(json: any): PixtaCategory {
    return PixtaCategoryFromJSONTyped(json, false);
}

export function PixtaCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PixtaCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PixtaCategoryToJSON(value?: PixtaCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

